/* main js */
import {Modal, Tabs} from "bootstrap";
import mainNavHandler from "./mainNavHandler";
import {matchMediaXlUp} from './mediaQuery';
import './swiper';
import scrollObserver from "./scrollObserver";

/* Constants */
const mainHeader = document.querySelector('#site-header');
const mainHeaderNavbar = mainHeader.querySelector('.navbar');
const mainNav = document.querySelector('#main-nav');

document.addEventListener('DOMContentLoaded', () => {
    // Force to start page on top
    if (history.scrollRestoration) {
        history.scrollRestoration = 'manual';
    } else {
        window.onbeforeunload = function () {
            window.scroll({top: 0, left: 0});
        }
    }

    // Main menu
    if (mainNav) mainNavHandler(mainNav);

    // Menu item cta HTML
    const menuItemCTA = document.querySelector('.menu-item-cta .dropdown-item');
    if (menuItemCTA) menuItemCTA.innerHTML = `<span>${menuItemCTA.textContent}</span><span class="icon icon--arrow"></span>`;

    /**
     * Detect scroll direction
     * @returns {boolean}
     */
    let lastScrollTop = 0;
    const isScrollingDown = () => {
        let goingDown = false;
        let st = window.scrollY || document.documentElement.scrollTop;
        goingDown = st > lastScrollTop;
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
        return goingDown;
    };

    /**
     * Toggle scroll direction body and navbar theme classes
     * Math.sign(window.scrollY) !== -1 for detecting Safari negative over-scroll
     */
    const handleBodyClassByScroll = () => {
        if (!document.body.classList.contains('mega-dropdown-shown')) {
            if (isScrollingDown()) {
                document.body.classList.remove("scroll-up");
                document.body.classList.add("scroll-down");
                mainHeaderNavbar.classList.replace('navbar-dark', 'navbar-light');
            } else if (Math.sign(window.scrollY) !== -1) {
                document.body.classList.add("scroll-up");
                document.body.classList.remove("scroll-down");
                mainHeaderNavbar.classList.replace('navbar-dark', 'navbar-light');
            }
            if (window.scrollY < 50 && Math.sign(window.scrollY) !== -1) {
                document.body.classList.remove("scroll-up");
                mainHeaderNavbar.classList.remove('navbar-dark', 'navbar-light');
                if (mainHeaderNavbar.dataset.theme) {
                    mainHeaderNavbar.classList.add(mainHeaderNavbar.dataset.theme);
                }
            }
        }
    };
    window.addEventListener("scroll", handleBodyClassByScroll);

    document.addEventListener('scroll', function() {
        const stickyElement = document.querySelector('[data-sticky="true"]');
        const offsetTop = stickyElement?.getBoundingClientRect().top;
        if (offsetTop === 0) {
            stickyElement?.classList.add('sticky-active');
        } else {
            stickyElement?.classList.remove('sticky-active');
        }
    });

    /**
     * Parallax
     * @type {NodeListOf<Element>}
     */
    const parallaxes = document.querySelectorAll('.parallax');
    if (parallaxes && parallaxes.length) {
        scrollObserver({items: parallaxes, rootMargin: "100px 0px"});
    }
});